import { Swiper as CommonSwiper } from 'antd-mobile';
var SwiperItem = CommonSwiper.Item;
export { CommonSwiper, SwiperItem };